import React from "react";
import { motion } from "framer-motion";
import { Heart, ChatCircle, ShareNetwork } from "@phosphor-icons/react";
import { imageSrc, CATEGORY_META } from "../lib/api";

const captions = [
  "okay but the packaging tho 💅",
  "the only ritual i'm consistent with",
  "soft launch but make it Seoul",
  "this hit different at 2am",
  "running on this & main-character energy",
  "if you know, you know",
  "bestie said it changed her skin",
  "behind every glow there's a Korean shelf",
];

export default function SocialTile({ product, index = 0 }) {
  const meta = CATEGORY_META[product.category] || { color: "from-pink-200 to-violet-200" };
  const caption = captions[index % captions.length];

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1], delay: (index % 4) * 0.06 }}
      data-testid={`social-tile-${product.id}`}
      className="group relative rounded-xl overflow-hidden aspect-[4/5] cursor-pointer"
    >
      <div className={`absolute inset-0 bg-gradient-to-br ${meta.color}`} />
      {product.image_url && (
        <img
          src={imageSrc(product.image_url)}
          alt={product.name}
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1000ms] ease-[cubic-bezier(0.22,1,0.36,1)]"
          loading="lazy"
          draggable={false}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/15 to-transparent" />

      <div className="absolute top-3 left-3 flex items-center gap-2">
        <div className="w-7 h-7 rounded-full bg-gradient-to-br from-[#FF6B9E] to-[#A78BFA] border border-white/80" />
        <div className="text-white">
          <div className="font-display text-[11px] font-bold tracking-wide">@hangang.global</div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
        <p className="text-[13px] leading-snug font-medium line-clamp-2">{caption}</p>
        <div className="mt-2.5 flex items-center gap-3 text-[11px] opacity-90">
          <span className="inline-flex items-center gap-1"><Heart size={12} weight="fill" /> {12 + (product.likes || 0) + index * 37}</span>
          <span className="inline-flex items-center gap-1"><ChatCircle size={12} weight="fill" /> {3 + index * 4}</span>
          <span className="inline-flex items-center gap-1 ml-auto"><ShareNetwork size={12} weight="fill" /></span>
        </div>
      </div>
    </motion.div>
  );
}
